
import * as Consts from "../ts/rlAdmin.consts";
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import { NotifyService } from "../services/notify-service";
import { SearchService } from "../services/search-service";
import { ListService } from "../services/list-service";
import { EntityService } from "../services/entity-service";
import { EntityConfigService } from "../services/entity-config-service";
import { UsageService } from "../services/usage-service";
import { ModalService } from "../services/modal-service";
import { AclService } from "../services/acl-service";
import { EventService } from "assets/app/services/event-service";

export function RLAmounts(): ng.IDirective {
    return {
        restrict: 'E',
        controller: RLAmountsController,
        bindToController: true,
        controllerAs: 'aVM',
        scope: {
            parentEntityId: '=',
            parentLocked: '=',
            amounts: '=',
            selectedAmounts: '=',
            refresh: "=",
            parentCurrencyCharData: '=?',
            relRecID: "=?relRecId",
            numFound: "=?",
            amountCatalogRels: "=?",
            amountCatalogRelationships: "=?"
        },
        template: require("/assets/app/templates/amounts.html")
    }
}

class RLAmountsController {
    static $inject = ['$rootScope', '$scope', '$window', "$q", '$uibModal', 'notifyService', 'searchService', 'listService',
        'entityService', 'entityConfigService', 'usageService', 'modalService', "aclService", "eventService"];

    allAmountsSelected: boolean = false;
    amounts: Models.IEntitySearchDoc[];

    parentCurrencyCharData: Models.ICharDataValue;
    parentEntityId: string;
    refresh: boolean;
    show: boolean = true;
    relRecID: number;
    relEntityID: string;
    parentCharTypeID: number;
    forceRefresh: boolean;

    customColumns: Models.ICustomUserColumns;

    page: number;
    pageCount: number;
    rowCount: number;
    numFound: number;
    sortField: string;
    sortDir: number;
    currentPreviewEntityID: string;
    availableColumns: Models.IListTableColumn[];
    amountHasCatalog: boolean;
    amountCatalogRels: { [key: number]: Models.IEntityRecIDTitle };
    amountInvoiceRels: { [key: number]: number };
    amountRows: Models.IListTableRow[];
    selectedAmounts: Models.IListTableRow[];
    amountCatalogRelationships: { [entityID: string]: Models.IEntityRelationship[] };

    constructor(
        private $rootScope: ng.IRootScopeService,
        private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private readonly $q: ng.IQService,
        private $uibModalService: ng.ui.bootstrap.IModalService,
        private notifyService: NotifyService,
        private searchService: SearchService,
        private listService: ListService,
        private entityService: EntityService,
        private entityConfigService: EntityConfigService,
        private usageService: UsageService,
        private modalService: ModalService,
        private aclService: AclService,
        private eventService: EventService) {

        this.rowCount = 10;
        this.page = 1;
        this.availableColumns = [];
        this.amountHasCatalog = false;
        this.amountInvoiceRels = {};
        this.amountRows = [];
        this.allAmountsSelected = false;

        this.$scope.$watchGroup([() => this.sortDir, () => this.sortField],
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    this.GetAmounts();
                }
            });

        $scope.$watchCollection(() => [this.relRecID, this.parentEntityId, this.customColumns], (newValue, oldValue) => {
            if (newValue[0] && newValue[1] && newValue[2] && newValue[2] != oldValue[2]) {
                var divID = Utils.IdBuilder.splitEntityID(this.parentEntityId).divID;
                this.parentCharTypeID = Utils.IdBuilder.splitEntityID(this.parentEntityId).charTypeID;
                this.relEntityID = Utils.IdBuilder.splitEntityID(this.parentEntityId).charTypeID == Consts.CharTypeIDs.invoice ? this.parentEntityId : Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.relationship, this.relRecID);
                this.GetAmounts();
            }
        });

        $scope.$watch(() => this.numFound, (newValue) => {
            if (newValue != undefined && newValue > 0) {
                this.pageCount = Math.ceil(this.numFound / this.rowCount);
            }
        });

        $scope.$watch(() => this.selectedAmounts, (newValue, oldValue) => {
            if (this.selectedAmounts && this.selectedAmounts.length == this.amountRows.length && this.amountRows.length > 0) {
                this.allAmountsSelected = true;
            }
            else {
                this.allAmountsSelected = false;
            }
        }, true);

        this.$scope.$on(Consts.Events.RefreshViewEntity, (e, data) => {
            this.currentPreviewEntityID = data;
        });

        this.getCharacteristicList(Consts.CharTypeIDs.amount);
    }

    private canDeleteResults: _.Dictionary<boolean> = {};
    private canEditResults: _.Dictionary<boolean> = {};

    amountParentInvoice(amt: Models.IEntitySearchDoc) {
        var hasParent = false;
        this.entityService.getEntityParentRelationship(amt.entityID, Consts.CharTypeIDs.invoice).then((res) => {
            hasParent = res.length > 0;
            if (hasParent) {
                this.amountInvoiceRels[amt.recordID] = res[0].parentRecID;
            }
        });
        return hasParent;
    }

    ColumnsSelected(columns: Models.ICustomUserColumns) {
        this.customColumns = columns;
    }

    private getCharacteristicList(charTypeID: number) {
        return this.entityConfigService.getCharacteristicList(charTypeID)
            .then((res) => {
                var columns = _.sortBy(res, (chr) => {
                    return chr.label;
                }).map((chr): Models.IListTableColumn => {
                    return {
                        solrLabel: Utils.CharUtil.GetCharSolrLabel(chr.dataTypeID, chr.multipleIndicator, chr.tagLabel),
                        label: chr.label,
                        characteristicID: chr.characteristicID,
                        formatter: Utils.CharUtil.GetFormatter(chr.dataTypeID),
                        dataTypeID: chr.dataTypeID,
                        systemIndicatorID: chr.systemIndicator,
                        multipleIndicator: chr.multipleIndicator
                    }
                });

                this.availableColumns = columns;
            });
    }


    private setupRows(amounts: Models.IEntitySearchDoc[], columns: Models.ICharacteristicMetaData[]) {
        this.amountRows = [];
        this.entityService.getEntityStatuses(Consts.CharTypeIDs.amount, amounts.map(a => a.recordID)).then((res) => {
            var lockedAmountRows = _.transform<Models.IEntityStatus, boolean>(res, function (acc, value, key) { (acc[key] = value.lockIndicator > 0) }, {});
            var allowedToDeleteRows = _.transform<Models.IEntityStatus, boolean>(res, function (acc, value, key) { (acc[key] = value.deleteIndicator > 0) }, {});
            if (this.customColumns != undefined) {
                this.amountRows = this.listService.GetRows(amounts, this.customColumns.columns, this.availableColumns, lockedAmountRows, allowedToDeleteRows);
            }
        });
    }

    PreviewAmount(amount: Models.IListTableRow) {
        var amountEntityID = Utils.IdBuilder.buildEntityID(0, Consts.CharTypeIDs.amount, amount.recordID);
        this.currentPreviewEntityID = amountEntityID;
        this.entityService.getEntityParentRelationship(amount.entityID, Utils.IdBuilder.splitEntityID(this.relEntityID).charTypeID).then((relRes) => {
            var amtToParentRel = Utils.IdBuilder.buildRelationshipID(relRes[0]);

            var relatedPromise = this.entityService.getEntityRelationships(amtToParentRel, Consts.CharTypeIDs.property).then(rel => {
                if (rel.length > 0) {
                    this.entityService.getEntity(amount.entityID).then(entRes => {
                        var amountWithCatalog = <Models.IAmountRelationshipPair>{ assetRels: rel, charDataCollection: entRes.charDataCollection, record: entRes.record };
                        this.$rootScope.$broadcast(Consts.Events.ViewEntityRelationshipPair, amountWithCatalog);
                    });
                }
                else {
                    this.$rootScope.$broadcast(Consts.Events.ViewEntity, amount.entityID);
                }
            });
        });

    }

    EditAmount(amount: Models.IListTableRow, parentCurrencyCharData: Models.ICharDataValue) {
        var divID = Utils.IdBuilder.splitEntityID(amount.entityID).divID;
        var entityID = Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.amount, amount.recordID);

        this.entityService.getEntityParentRelationship(entityID, Utils.IdBuilder.splitEntityID(this.relEntityID).charTypeID).then((nestedRelResult) => {
            var nestedRelID = Utils.IdBuilder.buildRelationshipID(nestedRelResult[0]);
            this.entityService.getEntityCharData(entityID).then((dataResult) => {
                var allRels: Models.IEntityRelationship[] = [];
                let promises: ng.IPromise<any>[] = [];
                this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.amount).then((ctResult) => {
                    ctResult.forEach(ct => {
                        var relatedPromise = this.entityService.getRelatedEntities(nestedRelID, ct.charTypeID).then(rel => {
                            if (rel.length > 0) {
                                rel.forEach(r => allRels.push(r.relationship));
                            }
                        });
                        promises.push(relatedPromise);
                    });
                    this.$q.all(promises).then(() => {
                        var modal = this.ShowEditModal(dataResult, this.parentEntityId, this.parentCurrencyCharData, ctResult.map(c => c.charTypeID), allRels, nestedRelID);
                        modal.then((cdc) => {
                            this.GetAmounts();
                            this.forceRefresh = true;
                            this.eventService.call(Consts.Events.RefreshTablesAndParents);
                        });
                    });
                });
            });
        });
    }

    ShowEditModal(amountData: Models.ICharDataCollection, parentEntityID: string, parentCurrencyCharData: Models.ICharDataValue, relatedCharTypeIDs: number[], allRels: Models.IEntityRelationship[], nestedRel: string) {
        return this.modalService.editEntityWithRelationships(amountData, this.relEntityID, parentCurrencyCharData, allRels, nestedRel, relatedCharTypeIDs, false, true);
    }

    ToggleSelectAllAmounts() {
        if (this.allAmountsSelected) {
            this.allAmountsSelected = false;
            this.selectedAmounts = [];
        }
        else {
            this.allAmountsSelected = true;
            this.selectedAmounts = this.amountRows.filter(a => !a.lockedIndicator);
        }
    }

    DeleteAmount(amount: Models.IListTableRow) {
        if (this.$window.confirm("Are you sure you want to delete this amount?")) {
            this.notifyService.startProgress();

            var divID = Utils.IdBuilder.splitEntityID(this.parentEntityId).divID;
            var parentCharType = Utils.IdBuilder.splitEntityID(this.parentEntityId).charTypeID;
            var entityID = Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.amount, amount.recordID);
            if (parentCharType == Consts.CharTypeIDs.invoice) {
                this.entityService.deleteEntity(entityID, this.parentEntityId).then((jobRes) => {
                  return this.modalService.jobProgress(jobRes.jobID, jobRes.jobTitle, null, false, false, false).then((jobFinished) => {
                        this.notifyService.notifySuccess("Amount deleted");
                        this.eventService.call(Consts.Events.RefreshTablesAndParents);
                    });
                },
                    () => {
                        this.notifyService.notifyError("Error deleting Amount");
                    })
                    .finally(() => {
                        this.notifyService.endProgress();
                    });
            }
            else {
                this.usageService.deleteAmount(entityID)
                    .then((result) => {
                        if (result) {
                            _.remove(this.selectedAmounts, (amt) => {
                                return amt.recordID == amount.recordID;
                            });
                            _.remove(this.amounts, (amt) => {
                                return amt.entityID == entityID;
                            });
                            this.notifyService.notifySuccess("Amount deleted");
                            this.eventService.call(Consts.Events.RefreshTablesAndParents);
                        } else {
                            this.notifyService.notifyError("Error deleting Amount");
                        }
                    })
                    .finally(() => {
                        this.notifyService.endProgress();
                    });
            }
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    CopySuccessful(newEntityID: string) {
        this.refresh = true;
    }

    PageChanged(page: number) {
        this.page = page;
        this.GetAmounts();
    }

    PageSizeChanged(pageSize: number) {
        this.page = 1;
        this.rowCount = pageSize;
        this.GetAmounts();
    }

    GetAmounts() {
        this.notifyService.startProgress();
        var divID = Utils.IdBuilder.splitEntityID(this.parentEntityId).divID;
        this.searchService.advancedSearch({
            charTypeID: Consts.CharTypeIDs.amount,
            relatedEntityID: this.relEntityID,
            searchGroups: [],
            keywords: undefined,
            rowCount: this.rowCount,
            page: this.page,
            sortDir: this.sortDir,
            sortField: this.sortField
        })
            .then((result) => {
                this.amounts = result.documents;
                let amtPromises: ng.IPromise<any>[] = [];
                this.amounts.forEach((amt) => {
                    var allRels: Models.IEntityRecIDTitle[] = [];
                    var amtCatalogRelationships: Models.IEntityRelationship[] = [];
                    let promises: ng.IPromise<any>[] = [];
                    this.amountParentInvoice(amt);
                    amtPromises.push(this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.amount).then((ctResult) => {
                        return this.entityService.getEntityParentRelationship(amt.entityID, Utils.IdBuilder.splitEntityID(this.relEntityID).charTypeID).then((relRes) => {
                            var amtToParentRel = Utils.IdBuilder.buildRelationshipID(relRes[0]);
                            ctResult.forEach(ct => {
                                var relatedPromise = this.entityService.getRelatedEntities(amtToParentRel, ct.charTypeID).then(rel => {
                                    if (rel.length > 0) {
                                        rel.forEach((r) => {
                                            allRels.push({ recID: r.record.recordID, title: r.record.title });
                                            amtCatalogRelationships.push(r.relationship);
                                        });
                                    }
                                });
                                promises.push(relatedPromise);
                            });
                            return this.$q.all(promises).then(() => {
                                if (allRels.length > 0) {
                                    this.amountHasCatalog = true;
                                    this.amountCatalogRels[amt.recordID] = allRels[0];
                                    this.amountCatalogRelationships[amt.entityID] = amtCatalogRelationships;
                                }
                            });
                        });
                    }));
                });
                return this.$q.all(amtPromises).then(() => {
                    return this.entityConfigService.getCharacteristicTemplate(Consts.CharTypeIDs.amount, this.amounts[0].templateID).then((cmdRes) => {
                        this.setupRows(this.amounts, cmdRes.characteristicMetaDatas)
                    });
                });
            }).finally(() => {
                this.notifyService.endProgress();
            });
    }

    CanDelete(amount: Models.IListTableRow) {
        if (amount != undefined) {
            var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.amount, amount.templateGroupID, amount.templateID);
            if (this.canDeleteResults[acl] == null) {
                this.canDeleteResults[acl] = Utils.AclUtil.hasDeleteAccess(this.aclService.acls, acl);
            }
            return this.canDeleteResults[acl];
        }
    }

    CanEdit(amount: Models.IListTableRow) {
        if (amount != undefined) {
            var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.amount, amount.templateGroupID, amount.templateID);
            if (this.canEditResults[acl] == null) {
                this.canEditResults[acl] = Utils.AclUtil.hasWriteAccess(this.aclService.acls, acl);
            }
            return this.canEditResults[acl];
        }
    }
}

